import React from 'react'

export const Section1 = () => {
    return (
        <section className="home_section1">
            <div className="container">
            <div className="row">
                <div className="col-md-6 mb-4">
                    <div className="jl_mright_wrapper jl_clear_at">
                        <div className="jl_mix_post">
                            <div className="jl_m_center blog-style-one blog-small-grid">
                                <div className="jl_m_center_w jl_radus_e">
                                    <div className="jl_f_img_bg" style={{backgroundImage: 'url("./img/kiri-atas.jpg")'}} />
                                    <a href="./img/kiri-atas.jpg" target="_blank" rel='noreferrer' className="jl_f_img_link" > <span className="jl_post_type_icon"><i className="jli-gallery" /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-4">
                    <div className="jl_mright_wrapper jl_clear_at">
                        <div className="jl_mix_post">
                            <div className="jl_m_center blog-style-one blog-small-grid">
                                <div className="jl_m_center_w jl_radus_e">
                                    <div className="jl_f_img_bg" style={{backgroundImage: 'url("./img/kanan-atas.jpg")'}} />
                                    <a href="./img/kiri-atas.jpg" target="_blank" rel='noreferrer' className="jl_f_img_link" > <span className="jl_post_type_icon"><i className="jli-gallery" /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-4">
                    <div className="jl_mright_wrapper jl_clear_at">
                        <div className="jl_mix_post">
                            <div className="jl_m_center blog-style-one blog-small-grid">
                                <div className="jl_m_center_w jl_radus_e">
                                    <div className="jl_f_img_bg" style={{backgroundImage: 'url("./img/kiri-bawah.jpg")'}} />
                                    <a href="./img/kiri-bawah.jpg" target="_blank" rel='noreferrer' className="jl_f_img_link" > <span className="jl_post_type_icon"><i className="jli-gallery" /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-4">
                    <div className="jl_mright_wrapper jl_clear_at">
                        <div className="jl_mix_post">
                            <div className="jl_m_center blog-style-one blog-small-grid">
                                <div className="jl_m_center_w jl_radus_e">
                                    <div className="jl_f_img_bg" style={{backgroundImage: 'url("./img/kanan-bawah-3.jpg")'}} />
                                    <a href="./img/kanan-bawah-3.jpg" target="_blank" rel='noreferrer' className="jl_f_img_link" > <span className="jl_post_type_icon"><i className="jli-gallery" /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </section>
    )
};